module.exports = {
        srcSet: "/_next/static/images/google-play-128-968aa482d93a5b3f.png"+" 128w"+","+"/_next/static/images/google-play-256-73129ac4360242ca.png"+" 256w"+","+"/_next/static/images/google-play-335-4e60b866e2faf62a.png"+" 335w",
        images: [{path: "/_next/static/images/google-play-128-968aa482d93a5b3f.png",width: 128,height: 45},{path: "/_next/static/images/google-play-256-73129ac4360242ca.png",width: 256,height: 89},{path: "/_next/static/images/google-play-335-4e60b866e2faf62a.png",width: 335,height: 117}],
        src: "/_next/static/images/google-play-335-4e60b866e2faf62a.png",
        toString: function(){return "/_next/static/images/google-play-335-4e60b866e2faf62a.png"},
        
        width: 335,
        height: 117
      }